import React from 'react';
import Btn from '../../../../../../../../components/btn';
import styles from './index.module.scss';

const ActionBtn = ({ onClick, type, children, ...props }) => {
  return (
    <Btn {...props} type={type} onClick={onClick} className={styles.root}>
      {children}
    </Btn>
  );
};

export default ActionBtn;
